import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
    private readonly _msalService = inject(MsalService);
    private readonly _msalBroadcastService = inject(MsalBroadcastService);
    private readonly _destroying$ = new Subject<void>();

    ngOnInit(): void {
        this._msalService.handleRedirectObservable().subscribe();

        this._msalBroadcastService.inProgress$
            .pipe(
                filter(
                    (status: InteractionStatus) => status === InteractionStatus.None
                ),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                this._checkAndSetActiveAccount();
            });
    }

    ngOnDestroy(): void {
        this._destroying$.next();
        this._destroying$.complete();
    }

    private _checkAndSetActiveAccount(): void {
        const activeAccount = this._msalService.instance.getActiveAccount();

        if (
            !activeAccount &&
            this._msalService.instance.getAllAccounts().length > 0
        ) {
            const accounts = this._msalService.instance.getAllAccounts();
            this._msalService.instance.setActiveAccount(accounts[0]);
        }
    }
}
